import { ViteSSG } from 'vite-ssg'
import { createPinia } from 'pinia'
import App from './App.vue'
import { routes, scrollBehavior } from './router'
import { initPostHog, captureEvent } from './plugins/posthog'
import { getAdminToken } from './services/adminApi'
import './styles/main.css'

export const createApp = ViteSSG(
  App,
  { routes, scrollBehavior },
  ({ app, router, isClient }) => {
    app.use(createPinia())

    if (!isClient) return

    initPostHog()

    router.beforeEach((to) => {
      if (to.meta.requiresAdmin && !getAdminToken()) {
        return { name: 'AdminLogin' }
      }
    })

    router.afterEach((to) => {
      if (to.meta.noindex) return
      captureEvent('$pageview', {
        path: to.path,
        name: typeof to.name === 'string' ? to.name : undefined,
      })
    })

    // Same-page anchor jumps used to inherit smooth scroll from a global
    // `html { scroll-behavior: smooth }` CSS rule. That rule raced with
    // Vue Router's scroll-to-top during route navigation (the smooth
    // animation fought the view swap, leaving users mid-page on the new
    // route), so the rule was removed. Restore smooth-scroll here only
    // for clicks on hash-only <a> links, with the same 72px header
    // offset the router's hash branch applies.
    document.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
      const anchor = (e.target as Element | null)?.closest<HTMLAnchorElement>('a[href^="#"]')
      if (!anchor) return
      const href = anchor.getAttribute('href')
      if (!href || href === '#' || href.length <= 1) return
      const el = document.getElementById(href.slice(1))
      if (!el) return
      e.preventDefault()
      const top = el.getBoundingClientRect().top + window.scrollY - 72
      window.scrollTo({ top, behavior: 'smooth' })
      history.pushState(null, '', href)
    })
  },
)
